import { render } from "./BrowsePaginationWrapper.vue?vue&type=template&id=3fd631b6"
import script from "./BrowsePaginationWrapper.vue?vue&type=script&lang=js"
export * from "./BrowsePaginationWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__